import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { theme } from '@features/executive-report/domain/theme';
import { Table, TableRow } from '@features/powerpoint';
import { postalCodeToStateName } from '@utils/states';
import {
  INDEX_WIDTH,
  NORMAL_WIDTH,
  ROWS_PER_TABLE,
  headersToTableRow,
  defaultTableOptions,
  cellOptionsByIndex,
  VISIT_INDEX_WIDTH,
} from './table-utils';
import { sortBy } from '@utils/arrays';

const headers = ['', 'State', 'Visit Index'].map(header =>
  header.toUpperCase()
);

export const statesTable = (
  stateVisits: CampaignAnalyticsReport['stateVisits']
): Table => {
  const topStatesRows: TableRow[] = stateVisits.data
    .toSorted(sortBy('visitIndex', 'desc'))
    .slice(0, ROWS_PER_TABLE)
    .map((stateVisit, index): TableRow => {
      const options = cellOptionsByIndex(index);

      return [
        {
          text: (index + 1).toString(),
          options: {
            ...options,
            color: theme.colors.lightBlue,
            align: 'center',
          },
        },
        {
          text:
            postalCodeToStateName[
              stateVisit.location as keyof typeof postalCodeToStateName
            ] ?? stateVisit.location,
          options: {
            ...options,
            bold: true,
          },
        },
        {
          text: stateVisit.visitIndex.toString(),
          options: {
            ...options,
            align: 'center',
          },
        },
      ];
    });

  return {
    tableRows: [headersToTableRow(headers), ...topStatesRows],
    options: {
      ...defaultTableOptions,
      colW: [INDEX_WIDTH, NORMAL_WIDTH, VISIT_INDEX_WIDTH],
    },
  };
};
